import {inject, Injectable} from "@angular/core";
import {ToasterService} from "../../globalServices/toaster.service";
import {IndividualConfig} from "ngx-toastr/toastr/toastr-config";


@Injectable({
    providedIn: 'root'
})
export class BaseCommon {

    protected toastService: ToasterService;

    // protected console: Console

    constructor() {
        this.toastService = inject(ToasterService);
    }

    showSuccess(message: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastService.showSuccess(message, title, {'positionClass': 'toast-center-center'});
    }

    showError(message: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastService.showError(message, title, {'positionClass': 'toast-center-center'});
    }

    showWarning(message: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastService.showWarning(message, title, {'positionClass': 'toast-center-center'});
    }

    showInfo(message: string, title?: string, override?: Partial<IndividualConfig>) {
        this.toastService.showInfo(message, title, {'positionClass': 'toast-top-right'});
    }

    // log(...data: any[]) {
    //     this.console.log(...data);
    // }

}
